module.exports = __webpack_public_path__ + "static/media/style2.38207308.svg";